import * as types from 'constants/ActionTypes';
import { createReducer } from 'utils/ReduxUtils';

/** @typedef {Array<import('modules/statistics/types').TimelineStatusReducer>} DealerTimelineReducer */
const initialState = [];

/**
 * @param {DealerTimelineReducer} _
 * @param {import('modules/statistics/types').FetchTimeLineStatusStatsSuccessAction} action
 * @returns {DealerTimelineReducer}
 */
const updateAllData = (_, { payload }) => payload.content;

export default createReducer(initialState, {
  [types.FETCH_STATISTICS_TIMELINE_STATUS_STATS_SUCCESS]: updateAllData,
});
